<template>
  <div class="home">
    <!-- 内容区域 - 暂时隐藏topics相关内容，待接口就绪后启用 -->
    <!-- <div v-if="loading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <div v-else-if="error" class="error-container">
      <p>加载失败：{{ error }}</p>
      <button @click="fetchData" class="retry-button">重试</button>
    </div>

    <div v-else>
      <div v-for="(item, index) in topics" :key="`topic-${item.id || index}`">
        <div v-if="item.themeType === 'one'" class="first-box">
          <div v-for="(image, imgIndex) in item.images" :key="`one-img-${image.id || imgIndex}`">
            <img 
              :src="trimImageUrl(image.url)" 
              :alt="item.name || 'Single Image'" 
              class="responsive-image"
              @click="goToDetail(image.id)"
              style="cursor: pointer;"
            >
          </div>
        </div>
        <div v-else-if="item.themeType === 'four'" class="second-box">
          <div v-for="(image, imgIndex) in item.images" :key="`four-img-${image.id || imgIndex}`" class="grid-item">
            <img 
              :src="trimImageUrl(image.url)" 
              :alt="item.name || 'Grid Image'" 
              class="responsive-image"
              @click="goToDetail(image.id)"
              style="cursor: pointer;"
            >
          </div>
        </div>
      </div>

      <div v-if="topics.length === 0" class="empty-container">
        <p>暂无数据</p>
      </div>
    </div> -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  setup() {
    // topics相关功能暂时隐藏，待接口 /jeecg-boot/drmotoev/topic/query-front 就绪后启用
    return {};
  }
});
</script>

<style scoped>
.home {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
  padding-bottom: 40px; /* 为footer留出空间 */
}

/* 保持其他样式不变 */
.first-box {
  width: 100%;
  max-width: 2000px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  margin-top: 80px;
  overflow: hidden; /* 防止内容溢出 */
}

/* second-box布局 - PC端 */
.second-box {
  width: 100%;
  max-width: 2000px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;
  padding: 0 30px;
  margin-top: 40px;
  overflow: hidden; /* 防止内容溢出 */
}

.grid-item {
  width: 100%;
  height: 100%;
  min-height: 200px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

/* 基础样式 - PC端 */
.responsive-image {
  width: 100%;
  max-width: 100%;
  height: 100%; /* 图片高度设置为100%以填充容器 */
  object-fit: contain; /* 保持图片比例，完全显示在容器内 */
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.responsive-image:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

/* 加载状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 100%;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #12aa4a;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 错误状态样式 */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 100%;
  color: #ff4d4f;
}

.retry-button {
  margin-top: 16px;
  padding: 6px 16px;
  background-color: #12aa4a;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.retry-button:hover {
  background-color: #0e8e3e;
}

/* 空数据状态样式 */
.empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  width: 100%;
  color: #999;
}

/* 平板端响应式调整 (769px - 1024px) */
@media (min-width: 769px) and (max-width: 1024px) {
  .first-box {
    padding: 0 20px;
    margin-top: 60px;
  }

  .second-box {
    padding: 0 20px;
    margin-top: 30px;
    gap: 15px;
  }

  .responsive-image {
    border-radius: 6px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  }

  .responsive-image:hover {
    transform: scale(1.01);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  }
}

/* 手机端响应式调整 (≤768px) */
@media (max-width: 768px) {
  .first-box {
    padding: 0 15px;
    margin-top: 30px;
  }

  .second-box {
    padding: 0 15px;
    margin-top: 20px;
    gap: 10px;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);
  }

  .grid-item {
    min-height: 150px;
  }

  .responsive-image {
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  /* 手机端移除hover效果，因为触摸设备不需要 */
  .responsive-image:hover {
    transform: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
}

</style>
